'use client';

import moment from 'moment';
import { useLocale } from 'next-intl';
import React, { useEffect } from 'react';
import * as gtm from '../lib/GTM';
import { init as initCleverTap } from '../lib/clevertap';
import useSession from '../stores/session/useSession';
import 'moment/locale/it';

export default function InitProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useSession();
  const locale = useLocale();

  useEffect(() => {
    moment.locale(locale);

    if (user) {
      gtm.addEmail(user.email);
    }

    initCleverTap(user);
  }, [user]);

  return (
    <>
      {children}
    </>
  );
}
